export default __webpack_public_path__ + "static/N0003-723127ecc95696b69792af335ac77a50.png";